import * as _ from "lodash";

var pageArray = <T>(collection: T[], pageSize: number): T[][] => {
    var output: T[][] = [];

    var page = -1;
    for (var i = 0; i < collection.length; i++) {
        var index = i % pageSize;
        if (index == 0) {
            page++;
            output[page] = [];
        }
        output[page].push(collection[i]);
    }
    return output;
};

_.mixin({ "pageArray": pageArray }, { "chain": true });

var foreachGraph = <T>(collection: T[], childAccessor: _.ListIterator<T, T[]>, action: (value: T) => void): void => {
    for (var i = 0; i < collection.length; i++) {
        var item = collection[i];
        action(item);
        foreachGraph(childAccessor(item, i, collection), childAccessor, action);
    }
};
_.mixin({ "foreachGraph": foreachGraph }, { "chain": true });

var arrayEqual = (collection: any[], toArray: any[]): boolean => {

    // if the other array is a falsy value, return
    if (!toArray)
        return false;

    // compare lengths - can save a lot of time 
    if (collection.length != toArray.length)
        return false;

    for (var i = 0, l = collection.length; i < l; i++) {
        // Check if we have nested arrays
        if (collection[i] instanceof Array && toArray[i] instanceof Array) {
            // recurse into the nested arrays
            if (!arrayEqual(<any[]>collection[i], <any[]>toArray[i]))
                return false;
        }
        else if (collection[i] != toArray[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;

};
_.mixin({ "arrayEqual": arrayEqual }, { "chain": true });


var selectMany = <T, TResult>(collection: T[], callback: _.ListIterator<T, TResult[]>): TResult[] => {
    var output: TResult[] = [];

    if (collection == null) {
        return output;
    }
    for (var i = 0; i < collection.length; i++) {
        var item = collection[i];
        var resultArray = callback(item, i, collection);
        output = output.concat(resultArray);
    }
    return output;
};

_.mixin({ "selectMany": selectMany }, { "chain": true });

var uniqueObjects = <T>(collection: T[]): T[] => {
    var output: T[] = [];

    collection.forEach((value) => {
        if (!_.any(output, (value2) => _.isEqual(value, value2))) {
            output.push(value);
        }
    });

    return output;
};

_.mixin({ "uniqueObjects": uniqueObjects }, { "chain": true });
